import React from "react"
import Box from "@material-ui/core/Box"
/** Components */
import Label from "components/Forms/Label"
import Value from "components/Forms/Value"
import StatusBlock from "components/Table/components/StatusBlock"

/** Config */
import vmsConfig from "config/Dashboard/VMS"
import ColorStatus from "utils/status"
import { fromUnix, fromUnixTime } from "utils/date"
/** Styles */
import styles from "./styles"

interface DetailsProps {
  data: Record<string, any> | undefined
}

const DetailsVisitors: React.FC<DetailsProps> = ({ data }) => {
  const classes = styles()

  function StatusType() {
    const type =
      data?.vms_type === 1 || data?.vms_type === 3
        ? vmsConfig.status.visitor
        : vmsConfig.status.delivery

    const currentStatus = data?.vms?.status

    return (
      <StatusBlock
        status={type[currentStatus]}
        color={ColorStatus.code(type[currentStatus])}
      />
    )
  }

  return (
    <Box className={classes.container}>
      <Box className={classes.content}>
        <Box width="60%" textAlign="center">
          {StatusType()}
        </Box>
      </Box>

      <Box className={classes.content}>
        <Box className={classes.title}>Personal Details</Box>

        <Box className={classes.twoCol}>
          <Box>
            <Label label="block/unit no." />
            <Value val={data?.vms?.for_admin ? "Admin" : data?.unit?.short_name} />
          </Box>
          {!data?.vms?.for_admin && (
            <Box>
              <Label label="name" />
              <Value val={data?.vms?.contact_person} />
            </Box>
          )}
        </Box>
      </Box>

      <Box className={classes.content}>
        <Box className={classes.title}>Visitor's Inforrmation</Box>
        <Box className={classes.block}>
          <Label label="name" />
          <Value val={data?.vms?.name} />
        </Box>
        <Box className={classes.block}>
          <Label label="OTP" />
          <Value val={data?.vms?.otp} />
        </Box>
        <Box className={classes.block}>
          <Box>
            <Label label="estimated time of arrival" />
            <Value
              val={`${fromUnix(data?.vms?.eta_ms)} ${fromUnixTime(
                data?.vms?.eta_ms
              )}`}
            />
          </Box>
        </Box>
        <Box className={classes.twoCol}>
          <Box>
            <Label label="multiple persons" />
            <Value val={data?.vms?.multiple_persons ? "Yes" : "No"} />
          </Box>
          {data?.vms?.multiple_persons && (
            <Box>
              <Label label="number of persons" />
              <Value val={data?.vms?.no_of_persons} />
            </Box>
          )}
        </Box>
        {data?.vms?.vehicle_no && (
          <Box className={classes.block}>
            <Label label="vehicle number" />
            <Value val={data?.vms?.vehicle_no} />
          </Box>
        )}
        <Box className={classes.block}>
          <Label label="remarks" />
          <Value val={data?.vms?.remarks} />
        </Box>
      </Box>
    </Box>
  )
}
export default DetailsVisitors
